import { cn } from '@/shadcn-ui/utils';
import LinkWithInventoryFilters from '../../link-with-inventory-filters';
import { DefaultLinkProps } from '@/common/types/default-link-props';

interface DirectoryLinkBlockProps {
  title: string;
  links: DefaultLinkProps[];
}

export default function DirectoryLinkBlock({ title, links }: DirectoryLinkBlockProps) {
  return (
    <div className="flex flex-col gap-[8px]">
      <p className={cn('homepage-footer font-bold')}>{title}</p>
      <div className="flex flex-col">
        {links.map((item) => (
          <LinkWithInventoryFilters
            className={cn('homepage-footer cursor-pointer hover:underline')}
            key={item.text}
            to={item.to}
            reloadDocument={item.reloadDocument}
          >
            {item.text}
          </LinkWithInventoryFilters>
        ))}
      </div>
    </div>
  );
}
